import type CampaignEditorComponent from './campaign-editor.component';
import {
  createUnsavedChangesGuard,
  setupBeforeUnloadGuard,
} from '../../../guards/unsaved-changes.guard';

/**
 * Route guard to prevent navigation away from campaign editor with unsaved changes.
 *
 * Protects against:
 * - Browser back button
 * - Navigation to other routes
 * - Page refresh / tab close (via `setupBeforeUnloadGuard`)
 */
export const canDeactivateCampaignEditor = createUnsavedChangesGuard<CampaignEditorComponent>(
  c => c.isDirty(),
  'You have unsaved changes. Are you sure you want to leave? All unsaved changes will be lost.',
  c => c.isDirty.set(false)
);

export { setupBeforeUnloadGuard as setupBeforeUnloadHandler };
